import(/* webpackMode: "eager" */ "/vercel/path0/src/app/android/page.tsx");
